import { isEmptyObject, objectOmitProperties } from '@app/utils/object'

import type { UseFieldArrayReturn } from 'react-hook-form'

const MAX_ITEMS_COUNT = 10

export const isShowRemoveButton = (fields: UseFieldArrayReturn['fields'], currentIndex: number): boolean => {
  const isNullSecondItem = isEmptyObject(objectOmitProperties(fields[1], 'id'))
  const isFieldsNotEmpty = fields.length > 1
  const isPreviousItem = fields.length !== currentIndex + 1
  const isLastItem = currentIndex === MAX_ITEMS_COUNT

  return isLastItem || (!isNullSecondItem && isPreviousItem && isFieldsNotEmpty)
}

export const isShowAppendButton = (fields: UseFieldArrayReturn['fields'], currentIndex: number): boolean => {
  const isMaxCountFields = fields.length <= MAX_ITEMS_COUNT
  const isLastField = fields.length === currentIndex + 1

  return isMaxCountFields && isLastField
}
